module.exports = __webpack_public_path__ + "img/Risk.b4b05a40.svg";